import { render, staticRenderFns } from "./article.vue?vue&type=template&id=640ea7f0"
import script from "./article.vue?vue&type=script&lang=js"
export * from "./article.vue?vue&type=script&lang=js"
import style0 from "./article.vue?vue&type=style&index=0&id=640ea7f0&prod&lang=css"
import style1 from "./article.vue?vue&type=style&index=1&id=640ea7f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports